/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import {
  FormRecordStockSummaryFieldComponent
} from "../../admin/form/form-record/fields/stock-summary/form-record-stock-summary-field.component";
/* eslint-enable */

export class FormRecordStockSummaryFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordStockSummaryFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
